module.exports = __webpack_public_path__ + "img/doc.8af7b037.svg";